/* import __COLOCATED_TEMPLATE__ from './loading.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import Component from '@glimmer/component';
import Theme from 'embercom/objects/inbox/types/theme';

export default class StandaloneCopilotLoading extends Component {
  get forcedTheme() {
    return window.location.search.includes('theme=dark') ? Theme.Dark : Theme.Light;
  }

  get isZendesk() {
    return window.location.search.includes('external_type=ZENDESK_TICKET');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Copilot::Loading': typeof StandaloneCopilotLoading;
  }
}
